
import Vue from 'vue';

import MobileTicketUser from './components/mobile-ticket/MobileTicketUser';
Vue.component(MobileTicketUser.name, MobileTicketUser);

import MobileTicketQRCodeDialog from './components/mobile-ticket/MobileTicketQRCodeDialog';
Vue.component(MobileTicketQRCodeDialog.name, MobileTicketQRCodeDialog);

import MobileTicketSolveDialog from './components/mobile-ticket/MobileTicketSolveDialog';
Vue.component(MobileTicketSolveDialog.name, MobileTicketSolveDialog);

import MobileTicketAssignDialog from './components/mobile-ticket/MobileTicketAssignDialog';
Vue.component(MobileTicketAssignDialog.name, MobileTicketAssignDialog);

import MobileSubmitButton from './components/mobile-ticket/MobileSubmitButton';
Vue.component(MobileSubmitButton.name, MobileSubmitButton);

import MobileTicketUpload from './components/mobile-ticket/MobileTicketUpload';
Vue.component(MobileTicketUpload.name, MobileTicketUpload);

import MobileTicketUploadBig from './components/mobile-ticket/MobileTicketUploadBig';
Vue.component(MobileTicketUploadBig.name, MobileTicketUploadBig);

import MobileTicketTaskForm from './components/mobile-ticket/MobileTicketTaskForm';
Vue.component(MobileTicketTaskForm.name, MobileTicketTaskForm);

import MobileTicketSearch from './components/mobile-ticket/MobileTicketSearch';
Vue.component(MobileTicketSearch.name, MobileTicketSearch);

import MobileTicketDetailMenu from './components/mobile-ticket/MobileTicketDetailMenu';
Vue.component(MobileTicketDetailMenu.name, MobileTicketDetailMenu);

import MobileTicketStatus from './components/mobile-ticket/MobileTicketStatus';
Vue.component(MobileTicketStatus.name, MobileTicketStatus);

import MobileTicketTabbar from './components/mobile-ticket/MobileTicketTabbar';
Vue.component(MobileTicketTabbar.name, MobileTicketTabbar);

import MobileTicketNew from './components/mobile-ticket/MobileTicketNew';
Vue.component(MobileTicketNew.name, MobileTicketNew);

import MobileTicketComplaintNew from './components/mobile-ticket/MobileTicketComplaintNew';
Vue.component(MobileTicketComplaintNew.name, MobileTicketComplaintNew);

import ToggleRadioItem from './components/mobile-ticket/ToggleRadioItem.vue';
Vue.component(ToggleRadioItem.name, ToggleRadioItem);

import MobileTicketList from './components/mobile-ticket/MobileTicketList';
Vue.component(MobileTicketList.name, MobileTicketList);

import MobileTicketTypePicker from './components/mobile-ticket/MobileTicketTypePicker';
Vue.component(MobileTicketTypePicker.name, MobileTicketTypePicker);

import MobileTicketTaskFormItem from './components/mobile-ticket/MobileTicketTaskFormItem';
Vue.component(MobileTicketTaskFormItem.name, MobileTicketTaskFormItem);


// WEBPACK FOOTER //
// ./src/components-ticket-mobile.js